module.exports = __webpack_public_path__ + "img/setup-your-organization.1e16e290.png";